export default __webpack_public_path__ + "img/b171f2c66733d5473e67f1b6d1a3347e.png";